import { render, staticRenderFns } from "./ServiceErrorMessage.vue?vue&type=template&id=5227dc28&scoped=true"
import script from "./ServiceErrorMessage.vue?vue&type=script&lang=js"
export * from "./ServiceErrorMessage.vue?vue&type=script&lang=js"
import style0 from "./ServiceErrorMessage.vue?vue&type=style&index=0&id=5227dc28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227dc28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5227dc28')) {
      api.createRecord('5227dc28', component.options)
    } else {
      api.reload('5227dc28', component.options)
    }
    module.hot.accept("./ServiceErrorMessage.vue?vue&type=template&id=5227dc28&scoped=true", function () {
      api.rerender('5227dc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channelManage/ServiceErrorMessage/ServiceErrorMessage.vue"
export default component.exports